// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__1PWE3","footer":"Footer_footer__3qkw7"};